// better-auth redirects a failed Google sign-in to `errorCallbackURL?error=<code>`.
const messages: Record<string, string> = {
    access_denied: "Google sign-in was cancelled. Please try again.",
    // An email/password account with this address exists but isn't verified, so
    // better-auth won't link the Google account to it.
    account_not_linked:
        "An account with this email already exists. Log in with your password and verify your email address, then you can use Google to log in.",
};

export function googleErrorMessage(error: string | undefined): string | null {
    if (!error) return null;
    return messages[error] ?? "Google sign-in failed. Please try again.";
}
